"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Base = require("../Base");

var _SharedStyles = require("./SharedStyles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SenaryHeader = _styledComponents.default.h6(_templateObject(), _SharedStyles.sharedHeadingStyles, _Base.h6);

SenaryHeader.displayName = 'SenaryHeader';
SenaryHeader.propTypes = {
  /** Heading content */
  children: _propTypes.default.node.isRequired
};
var _default = SenaryHeader;
exports.default = _default;